import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";

import BrokerModal from "./BrokerModal";
import RemoveModal from "components/common/modals/RemoveModal";
import SingleBrokerRow from "./SingleBrokerRow";
import Header from "components/common/tablePages/Header";

import brokerSettingsService from "services/brokers-service";
// Assets
import bagImg from "../../assets/images/bag-with-arrow.png";
import bagImgSmall from "../../assets/images/bag-with-arrow-small.png";

import "./Broker.css";
import axios from "axiosConfig";


// Mock data
// const mockBrokers = [
//   {
//     accountName: "RZ17308",
//     broker: "Interactive",
//     client_id: 243,
//     created_at: new Date(),
//     clientID: 243,
//     dateAdded: "13/01/2022",
//   },
//   {
//     accountName: "RZ17308",
//     broker: "Interactive",
//     client_id: 243,
//     created_at: new Date(),

//     clientID: 243,
//     dateAdded: "13/01/2022",
//   },
//   {
//     accountName: "RZ17308",
//     broker: "Interactive",
//     client_id: 243,
//     created_at: new Date(),
//     clientID: 243,
//     dateAdded: "13/01/2022",
//   },
// ];


const Broker = () => {
  const [isBrokerModal, setIsBrokerModal] = useState(false);
  const [isRemoveBrokerModal, setIsRemoveBrokerModal] = useState(false);
  const [isShowEditModal, setIsShowEditModal] = useState(false);
  const [input, setInput] = useState("");
  const [brokers, setBrokers] = useState([]);
  const [selectedBroker, setSelectedBroker] = useState({});
  const [filteredBrokers, setFilteredBrokers] = useState([]);
  useEffect(() => {
    // ...

    const fetchData = async () => {
      try {
        const brokerSettings = await brokerSettingsService.getBrokerSettings(
          "/"
        );
        const dateOptions = { day: "numeric", month: "short", year: "numeric" };
        const formattedBrokerSettings = brokerSettings.map((setting) => ({
          ...setting,
          created_at: new Date(setting.created_at).toLocaleDateString(
            "en-GB",
            dateOptions
          ), // Change the date format
        }));
        // Set the brokers variable:
        setBrokers(formattedBrokerSettings);
        setBrokers(brokerSettings);
      } catch (error) {
        console.log("Error fetching brokerSettings:", error);
      }
    };

    fetchData();

    // ...
  }, []);
  useEffect(() => {
    const filteredData = brokers.filter((brokerData) => {
      // Filter brokers by the `input` value. If `input` is empty, all brokers will be displayed.
      const brokerMatches = brokerData.broker.toLowerCase().includes(input.toLowerCase());
      const accountNicknameMatches = brokerData.account_nickname.toLowerCase().includes(input.toLowerCase());
      const clientIdMatches = brokerData.client_id.toLowerCase().includes(input.toLowerCase());
      // Return true if any of the search criteria match
      return brokerMatches || accountNicknameMatches || clientIdMatches;
    });

    setFilteredBrokers(filteredData);
  }, [input, brokers]);
  const handleSearch = (e) => {
    const value = e.target.value;
    setInput(value);
  };


  const handleDeleteBroker = async () => {
    try {
      const res = await axios.delete(`api/brokersetting/${selectedBroker.id}/`);
      setBrokers((prev) => {
        const newBrokers = [...prev];
        const index = newBrokers.indexOf(selectedBroker);
        newBrokers.splice(index, 1);
        return newBrokers;
      });
      setIsRemoveBrokerModal(false);
    } catch (error) {
      console.log("Error removing broker: " + error.message);
    }
  };

  // Each function triggers modal opening
  const showAddBrokerModal = () => {
    setIsBrokerModal(true);
    setIsShowEditModal(false);
  };
  const showEditBrokerModal = (brokerData) => {
    setSelectedBroker(brokerData);

    setIsBrokerModal(true);
    setIsShowEditModal(true);
  };
  const showRemoveBrokerModal = () => {
    setIsRemoveBrokerModal(true);
  };

  return (
    <section id="brokers-section" className="mb-0">
      <Header
        title="Servus, your brokers listed with us."
        titleEmpty="We await your first broker!"
        text="Broker management is easy with your Servus. Add/Delete/Edit your broker at any time."
        btnText="Add Broker"
        imgBig={bagImg}
        imgSmall={bagImgSmall}
        isEmpty={brokers.length === 0 ? true : false}
        setIsModal={setIsBrokerModal}
      />
      <div
        className={
          brokers.length === 0 ? "brokers-table d-none" : "brokers-table"
        }
      >
        <Container
          className={`mt-5  ${
            brokers.length === 0 ? "d-none" : "d-block d-lg-block"
          }`}
        >
          <Row>
            <Col className="d-block d-lg-flex p-0 justify-content-between gap-3 mb-4">
              <InputGroup
                size="sm"
                className="dark-input mb-3 mb-lg-auto w-auto"
              >
                <InputGroup.Text id="search-input-label">
                  <i className="bi bi-search"></i>
                </InputGroup.Text>
                <Form.Control
                  id="search-input"
                  aria-label="search"
                  aria-describedby="search-input-label"
                  placeholder="Search Now"
                  name="Search"
                  value={input}
                  onChange={handleSearch}
                />
              </InputGroup>

              <button
                className="btn btn-primary text-md btn-block btn-full full-width-sm"
                onClick={showAddBrokerModal}
              >
                <i className="bi bi-plus"></i> Add Broker
              </button>
            </Col>
          </Row>
        </Container>
        <Container className="brokers">
          {/* Table */}
          <Row>
            {/* Controllers */}

            {/* Table header */}
            <Col className="d-none d-lg-flex justify-content-between lighter-section px-4 py-3 mb-3">
              <Col sm={2}>Account Name</Col>
              <Col className="d-flex justify-content-between align-content-center">
                <Col sm={2}>Broker</Col>

                <Col sm={2}>Client ID</Col>

                <Col sm={2}>Date Added</Col>
                <Col sm={2}>Off/On</Col>
                <Col sm={1}>Action</Col>
              </Col>
            </Col>
          </Row>
          {/* Table child rows */}
          {filteredBrokers.map(broker => (
            <SingleBrokerRow
              brokerData={broker}
              showModal={showEditBrokerModal}
              setData={setBrokers}
              setSelectedBroker={setSelectedBroker}
              showRemoveBrokerModal={showRemoveBrokerModal}
              key={broker.id}
            />
          ))}
        </Container>
      </div>
      {/* Modals */}
      {isBrokerModal && (
        <BrokerModal
          show={isBrokerModal}
          setShow={setIsBrokerModal}
          setBrokers={setBrokers}
          isShowEditModal={isShowEditModal}
          brokerData={isShowEditModal ? selectedBroker : {}}
        />
      )}
      <RemoveModal
        show={isRemoveBrokerModal}
        handleClick={handleDeleteBroker}
        setShow={setIsRemoveBrokerModal}
        header="Are you sure you want to Delete this Broker?"
      />
    </section>
  );
};
export default Broker;
